import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import sal from "sal.js"
import "media-chrome"
import "vimeo-video-element"
import "youtube-video-element"
import Swiper from 'swiper'
import { Autoplay, Navigation, Pagination, EffectCards } from 'swiper/modules'
import 'swiper/css'
import './main.css'

// Tailwind Class Safelist (for when media components have custom classed added): 
// WIDTH:   w-auto w-fit !w-200 !w-auto max-w-150 max-w-640 max-w-336
// MARGINS: my-40 mx-auto -my-105 mb-80 !mt-0 !mb-0
// BORDERS: border-25 sm:border-40 lg:border-100 border-[#e2e2e2] 
// MISC:    !h-full object-cover object-top object-bottom object-center

// Active HMR
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR")
  });
}

// Swiper setup
window.Swiper = Swiper
Swiper.use([Navigation, Pagination, Autoplay, EffectCards]);

// Alpine setup
window.Alpine = Alpine
Alpine.plugin(intersect)
Alpine.start();

// Init sal.js animations
sal({
  threshold: 0.4
})